import React, { useEffect, useRef} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoStar, Select, Button } from '../../components'
import './comentarios.scss'
import Filter from './filter/filter'
import { setProjeto, modalOpen } from '../../layout/redux/layoutActions'
import Tabela from './tabela'
import { filterHandle, listarComentarios, setSobreComentario, listSobreComentario, setFiltersProvisorio } from './redux/comentariosActions'
//import { useParams } from 'react-router-dom'
import Video from '../videos/video'
import Criar from '../dashboard/criar'
import Listar from '../dashboard/listar'
import CriarDashboardButton from '../dashboard/criardashboardbutton'
import { history } from '../../helpers'




export default () => {
  const dispatch = useDispatch()
  const { grupos, grupo, filters, empresa, categoria, sistema } = useSelector(state=> state.layoutState)
  const { projeto, filtersProvisorio, projetos, paginate, totalAvaliacao, sobreComentarios, sobreComentario } = useSelector(state=> state.comentariosnovosState)

  const nls = require(`./nls/${sistema.idioma}.json`)



  //USADO CASO O USUÁRIO DER REFRESH NA PÁGINA
  useEffect(() => {
  const wasRefreshed = sessionStorage.getItem('wasRefreshed')
  
  if (wasRefreshed === 'true' && projeto && projeto.id) {
    sessionStorage.removeItem('wasRefreshed')
    dispatch(setProjeto(projeto)) // ← Isso já dispara toda a cadeia!
  }

  const handleBeforeUnload = () => {
    sessionStorage.setItem('wasRefreshed', 'true')
  }
  
  window.addEventListener('beforeunload', handleBeforeUnload)
  return () => window.removeEventListener('beforeunload', handleBeforeUnload)
}, [projeto, dispatch])



  // Corrigindo a declaração do useRef
  const prevDeps = useRef({ projeto, empresa, categoria, sobreComentario });

//const { idProjetos  } = useParams()

//console.log("🔍 ZZZ ID da URL:", idProjetos)
  //console.log("📦 ZZZ Lista de projetos:", projetos.map(p => p.id))
  ////console.log("👁️ ZZZ Projeto atual:", projeto?.id)

  //O CÓDIGO ABAIXO GERAVA FLICKER NA PÁGINA PORQUE CHAMAVA 2 VEZES GETCOMENTARIOSTUDO
  
  
  const atualizarLista = e => {
    const value = nls.sobrecomentarios.filter(f=> projeto[`temMenu${f.has}`] ? f : null)
    //console.log("valorxxx", value)
    //console.log("valorxxxprojeto", projeto)
    dispatch(listSobreComentario(value))
    if (value.length) {
      dispatch(setSobreComentario(value[0]))      
    }
  }

  useEffect(()=> {
    atualizarLista()
  }, [projeto])

  useEffect(()=> {
    //console.log("sobrecomentario", sobreComentario)
    
    if (projeto.id) {
      if (filters.typeSelect) {
        dispatch(filterHandle({projetoID: projeto.id, grupo, params: filters, filtersProvisorio, typeSelect: filters.typeSelect, idioma: sistema.idiomaIdValue, tipo: sobreComentario?.tipo}))        
      } else {
        dispatch(listarComentarios({projetoID: projeto.id}))       
      }
    }
  }, [projeto, empresa, categoria, sobreComentario])


  const handleFormProjeto = (e) => {
    dispatch(setProjeto(e.value))
    
  }
  
  const handleFormAssunto = (e) => {
    dispatch(setSobreComentario(e.value))
  }  

  
  const handleAbrirCriarDashboard = () => {
  dispatch(modalOpen('criar'))
}

const handleAbrirListarDashboards = () => {
    dispatch(modalOpen('listar'))
  }


  return (
    <div className='box-comentarios' data-cy='page-feedbacks'>
      <div className='box-comentarios-topinfo'>
        <div>
          <div className='box-comentarios-topinfo-select'>
            <Select 
            cy='filter-project'
              name='projeto'
              label={nls.projeto}
              options={projetos}
              selected={projeto}
              action={(e)=> handleFormProjeto(e)}
              selectedItem={false}
              optionLabel='nomeProjeto'
              optionValue='id'
            />
          </div>

          <div className='box-comentarios-topinfo-select'>
            <Select 
            cy='filter-feedback-type'
              name='assunto'
              label={nls.assunto}
              //options={sobrecomentariosassunto}
              options={sobreComentarios}  
              selected={sobreComentario} 
              action={(e)=> handleFormAssunto(e)}
              selectedItem={false}
              optionLabel='assunto'
              optionValue='id'
            />
          </div>         
        </div>
        <div className='box-comentarios-topinfo-avaliacao'>
            <label>{nls.numerodeavaliacoes}</label>
            <IcoStar />
            <strong data-cy='feedback-count'>{totalAvaliacao?totalAvaliacao:0}</strong>
        </div>
      </div>
      <Filter />

      <div className="box-comentarios-video">
        <Video videoName="video1" cy="tutorial" />

        {projeto?.tipoProjetoId &&
        projeto.tipoProjetoId !== 2 &&
        filters?.ciclo &&
        filters.ciclo.anoMesCiclo && (
            <CriarDashboardButton
            cy="dashboard-create-open"
              onClick={handleAbrirCriarDashboard}
            />
        )}

      </div>


        <Tabela />
        <Criar />
        

    </div>

  )
}